import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export const RestaurantFeedback = () => {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/restaurant/feedback").then(({ data }) => setList(data)); }, []);

  const filtered = useMemo(() => {
    if (filter === "all") return list;
    return list.filter((f) => f.rating === Number(filter));
  }, [list, filter]);

  return (
    <div data-testid="rest-feedback">
      <h1 className="text-2xl font-bold">Customer feedback</h1>
      <p className="text-sm text-zq-muted mt-1">Reviews from customers via the menu page.</p>

      <div className="flex gap-2 mt-5">
        {["all", 5, 4, 3, 2, 1].map((r) => (
          <button
            key={r}
            className={`zq-pill ${String(filter) === String(r) ? "zq-pill-orange" : "zq-pill-gray"}`}
            onClick={() => setFilter(r)}
            data-testid={`filter-${r}`}
          >
            {r === "all" ? "All" : `${r} ★`}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        {filtered.length === 0 && <div className="zq-card p-6 text-zq-muted">No feedback yet.</div>}
        {filtered.map((f) => (
          <div key={f.id} className="zq-card p-5">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-semibold">{f.name}</div>
                <div className="text-xs text-zq-muted">{f.phone} · {new Date(f.created_at).toLocaleDateString("en-IN")}</div>
              </div>
              <div className="flex">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={14} fill={i < f.rating ? "#F97316" : "transparent"} stroke="#F97316" />
                ))}
              </div>
            </div>
            {f.message && <p className="text-sm mt-3">{f.message}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
